import { render, staticRenderFns } from "./ExcelColumnSetting.vue?vue&type=template&id=117227c5"
import script from "./ExcelColumnSetting.vue?vue&type=script&lang=js"
export * from "./ExcelColumnSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports